"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronDown, Menu } from "lucide-react";
import Link from "next/link";
import { PATH_ABOUT, PATH_DASHBOARD, PATH_PAGE } from "~/routes/paths";
import Logo from "~/shadcn/logo";
import { Button } from "~/shadcn/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "~/shadcn/ui/dropdown-menu";
import { Sheet, SheetContent, SheetTrigger } from "~/shadcn/ui/sheet";
import { ModeToggle } from "../theme-provider/toggle";
import { HomeSidebarContent } from "./home-sidebar-content";
import LanguagePopover from "./language-popover";
type Props = {
  dict: Dictionary;
  lang: AppLocale;
};
export default function HomeNavbar(t0) {
  const $ = _c(82);
  const {
    lang,
    dict
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Logo />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== lang) {
    t2 = PATH_PAGE.about(lang);
    $[1] = lang;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = dict["Om oss"];
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <Button variant="link" asChild={true} className="text-muted-foreground dark:text-foreground transition-colors hover:text-foreground"><Link href={t2}>{t3}</Link></Button>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = dict["V\xE5ra anslag"];
  let t6;
  if ($[6] !== t5) {
    t6 = <span>{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChevronDown className="h-4 w-4" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <DropdownMenuTrigger id="nav-grants-trigger" asChild={true}><Button variant="link" className="text-muted-foreground dark:text-foreground hover:no-underline transition-colors hover:text-foreground">{t6}{t7}</Button></DropdownMenuTrigger>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = dict["Musikstuderande p\xE5 h\xF6gskoleniv\xE5"];
  let t10;
  if ($[11] !== t9) {
    t10 = <DropdownMenuLabel className="cursor-default">{t9}</DropdownMenuLabel>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <DropdownMenuSeparator />;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== lang) {
    t12 = PATH_ABOUT.students(lang);
    $[14] = lang;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const t13 = dict["Musikstuderande p\xE5 h\xF6gskoleniv\xE5"];
  let t14;
  if ($[16] !== t12 || $[17] !== t13) {
    t14 = <DropdownMenuItem asChild={true} className="cursor-pointer"><Link href={t12}>{t13}</Link></DropdownMenuItem>;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <DropdownMenuSeparator />;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== dict.Organisationer) {
    t16 = <DropdownMenuLabel className="cursor-default">{dict.Organisationer}</DropdownMenuLabel>;
    $[20] = dict.Organisationer;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <DropdownMenuSeparator />;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== lang) {
    t18 = PATH_ABOUT.education(lang);
    $[23] = lang;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== dict.Utbildning || $[26] !== t18) {
    t19 = <DropdownMenuItem asChild={true} className="cursor-pointer"><Link href={t18}>{dict.Utbildning}</Link></DropdownMenuItem>;
    $[25] = dict.Utbildning;
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== lang) {
    t20 = PATH_ABOUT.childcare(lang);
    $[28] = lang;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  const t21 = dict["Barn med s\xE4rskilda behov"];
  let t22;
  if ($[30] !== t20 || $[31] !== t21) {
    t22 = <DropdownMenuItem asChild={true} className="cursor-pointer"><Link href={t20}>{t21}</Link></DropdownMenuItem>;
    $[30] = t20;
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== lang) {
    t23 = PATH_ABOUT.integration(lang);
    $[33] = lang;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== dict.Integrationsarbete || $[36] !== t23) {
    t24 = <DropdownMenuItem asChild={true} className="cursor-pointer"><Link href={t23}>{dict.Integrationsarbete}</Link></DropdownMenuItem>;
    $[35] = dict.Integrationsarbete;
    $[36] = t23;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <DropdownMenuSeparator />;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== dict.Forskare) {
    t26 = <DropdownMenuLabel className="cursor-default">{dict.Forskare}</DropdownMenuLabel>;
    $[39] = dict.Forskare;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  let t27;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <DropdownMenuSeparator />;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== lang) {
    t28 = PATH_ABOUT.research(lang);
    $[42] = lang;
    $[43] = t28;
  } else {
    t28 = $[43];
  }
  let t29;
  if ($[44] !== dict.Forskare || $[45] !== t28) {
    t29 = <DropdownMenuItem asChild={true} className="cursor-pointer"><Link href={t28}>{dict.Forskare}</Link></DropdownMenuItem>;
    $[44] = dict.Forskare;
    $[45] = t28;
    $[46] = t29;
  } else {
    t29 = $[46];
  }
  let t30;
  if ($[47] !== t10 || $[48] !== t14 || $[49] !== t16 || $[50] !== t19 || $[51] !== t22 || $[52] !== t24 || $[53] !== t26 || $[54] !== t29) {
    t30 = <DropdownMenuContent align="end">{t10}{t11}{t14}{t15}{t16}{t17}{t19}{t22}{t24}{t25}{t26}{t27}{t29}</DropdownMenuContent>;
    $[47] = t10;
    $[48] = t14;
    $[49] = t16;
    $[50] = t19;
    $[51] = t22;
    $[52] = t24;
    $[53] = t26;
    $[54] = t29;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== t30 || $[57] !== t8) {
    t31 = <DropdownMenu>{t8}{t30}</DropdownMenu>;
    $[56] = t30;
    $[57] = t8;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== lang) {
    t32 = PATH_DASHBOARD.applications.root(lang);
    $[59] = lang;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] !== dict.Ansökningar || $[62] !== t32) {
    t33 = <Button variant="link" asChild={true} className="text-muted-foreground dark:text-foreground transition-colors hover:text-foreground"><Link href={t32}>{dict.Ansökningar}</Link></Button>;
    $[61] = dict.Ansökningar;
    $[62] = t32;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== lang) {
    t34 = PATH_PAGE.contact(lang);
    $[64] = lang;
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] !== dict.Kontakt || $[67] !== t34) {
    t35 = <Button variant="link" asChild={true} className="text-muted-foreground dark:text-foreground transition-colors hover:text-foreground"><Link href={t34}>{dict.Kontakt}</Link></Button>;
    $[66] = dict.Kontakt;
    $[67] = t34;
    $[68] = t35;
  } else {
    t35 = $[68];
  }
  let t36;
  if ($[69] !== t31 || $[70] !== t33 || $[71] !== t35 || $[72] !== t4) {
    t36 = <nav className="hidden flex-col gap-6 text-lg font-medium md:flex md:flex-row md:items-center md:gap-5 md:text-sm lg:gap-6">{t1}{t4}{t31}{t33}{t35}</nav>;
    $[69] = t31;
    $[70] = t33;
    $[71] = t35;
    $[72] = t4;
    $[73] = t36;
  } else {
    t36 = $[73];
  }
  let t37;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <SheetTrigger id="nav-mobile-trigger" asChild={true}><Button variant="outline" size="icon" className="shrink-0 md:hidden"><Menu className="h-5 w-5" /><span className="sr-only">Toggle navigation menu</span></Button></SheetTrigger>;
    $[74] = t37;
  } else {
    t37 = $[74];
  }
  let t38;
  if ($[75] !== dict || $[76] !== lang) {
    t38 = <Sheet>{t37}<SheetContent side="left" className="w-full max-w-sm"><HomeSidebarContent lang={lang} dict={dict} /></SheetContent></Sheet>;
    $[75] = dict;
    $[76] = lang;
    $[77] = t38;
  } else {
    t38 = $[77];
  }
  let t39;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <div className="flex w-full items-center justify-end gap-4 md:ml-auto"><LanguagePopover /><ModeToggle /></div>;
    $[78] = t39;
  } else {
    t39 = $[78];
  }
  let t40;
  if ($[79] !== t36 || $[80] !== t38) {
    t40 = <header className="sticky z-10 top-0 flex h-16 items-center gap-4 border-b bg-background px-4 md:px-6">{t36}{t38}{t39}</header>;
    $[79] = t36;
    $[80] = t38;
    $[81] = t40;
  } else {
    t40 = $[81];
  }
  return t40;
}